import Vue from 'vue'
import App from './App.vue'
import router from './router'

// ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import BaiduMap from 'vue-baidu-map';
import "babel-polyfill";
import MetaInfo from 'vue-meta-info'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(BaiduMap, {
  ak: 'cIaugraO6p3anIRMOqGufIv1rBUwNVR5'
})

Vue.use(MetaInfo)

new Vue({
	el: '#app',
	router,
  render: h => h(App),
}).$mount('#app')
